// For posterity, this structure is based on the nivo library which relies on the SVGLinearGradientElement
// https://github.com/plouc/nivo/blob/master/packages/core/index.d.ts#L343

export default [
  {
    id: 'radialGradientFigmaPurpleOptimization',
    type: 'radial',
    colors: [
      {
        offset: 0,
        color: 'rgba(238, 63, 63, 0.5)',
        opacity: 0.5,
      },
      {
        offset: 0.33,
        color: 'rgba(169, 95, 241, 0.5)',
        opacity: 0.5,
      },
      {
        offset: 1,
        color: 'rgba(128, 158, 244, 0.5)',
        opacity: 0.5,
      },
    ],
  },
  {
    id: 'radialGradientFigmaPurpleBias',
    type: 'radial',
    colors: [
      {
        offset: 0,
        color: 'rgba(128, 158, 244, 0.5)',
        opacity: 0.5,
      },
      {
        offset: 0.33,
        color: 'rgba(169, 95, 241, 0.5)',
        opacity: 0.5,
      },
      {
        offset: 1,
        color: 'rgba(238, 63, 63, 0.5)',
        opacity: 0.5,
      },
    ],
  },
];
